// extracted by mini-css-extract-plugin
export default {"cardContainer":"BlogCard_cardContainer__cTuDm","heading":"BlogCard_heading__TNXs+"};